<template>
  <section class="p-2">
    <v-card class="">
      <v-card-title class="d-flex justify-space-between p-0 m-0">
        <div class="ps-2 headingFontsize">Transaction</div>
        <div>
          <bread-crumb :bread-crumbs="['Transaction']" />
        </div>
      </v-card-title>
      <v-divider class="p-0 m-0 primary--text"></v-divider>
      <v-card-text class="pb-0">
        <v-container> </v-container>
        <v-card class="pa-2 bord-color" elevation="0" rounded outlined>
          <v-sheet
            class="v-sheet--offset ms-4 pt-1 text-center"
            elevation="0"
            outlined
            width="90px"
          >
            <p class="font-weight-bold">
              <v-icon small class="me-1" color="secondary">mdi-filter</v-icon
              >Filters
            </p>
          </v-sheet>
          <v-row class="ps-2">
            <!-- <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                placeholder="Beneficiary Name"
                outlined
                :items="transactionList"
                dense
                clearable
                v-model="searchInputs.beneficiary_name"
              ></v-text-field>
            </v-col> -->
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                placeholder="Transaction ID"
                outlined
                :items="transactionList"
                dense
                clearable
                v-model="searchInputs.pin_number"
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-autocomplete
                :items="[
                  { text: 'Paid', value: 'Paid' },
                  { text: 'Posted', value: 'Posted' },
                  { text: 'Unpaid', value: 'Unpaid' },
                  { text: 'On-Hold', value: 'On-Hold' },
                  { text: 'ALL', value: 'All' },
                ]"
                placeholder="Transaction status"
                outlined
                dense
                clearable
                v-model="searchInputs.txn_status"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-autocomplete
                placeholder="Partner"
                item-text="txt"
                item-value="val"
                :items="senderPartners"
                outlined
                dense
                clearable
                v-model="searchInputs.partner_id"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                :items="transactionList"
                v-model="searchInputs.from_date"
                type="date"
                :rules="[validateFromDate]"
                label="From Transaction Date"
                outlined
                dense
                clearable
              ></v-text-field>
            </v-col>

            <v-col cols="12" lg="2" sm="6" xs="12">
              <v-text-field
                :items="transactionList"
                v-model="searchInputs.to_date"
                type="date"
                :rules="[validateToDate]"
                label="To Transaction Date"
                outlined
                dense
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" lg="2" sm="6" xs="12" class="d-flex">
              <v-btn
                depressed
                class="primary text-capitalize"
                @click="getTransaction()"
                small
                >Get Results</v-btn
              >
              <v-btn
                depressed
                class="mx-2 primary text-capitalize"
                small
                @click="clear()"
                >Clear</v-btn
              >
            </v-col>
          </v-row>
        </v-card>
      </v-card-text>

      <v-card-text>
        <v-row>
          <v-btn
            depressed
            @click="downloadExcelsheet"
            class="mt-2 ms-1"
            color="primary"
            small
            ><v-icon small>mdi-file-excel-outline</v-icon>Export
          </v-btn>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Type here to filter values."
            hide-details
            dense
            single-line
            clearable
            class="mt-2"
          ></v-text-field
        ></v-row>
      </v-card-text>

      <v-data-table
        fixed-header
        height="55vh"
        :headers="headers"
        :items="transactionList"
        :items-per-page="10"
        :search="search"
        :loading="isLoading"
        @item-expanded="loadDetails"
        loading-text="Loading... Please wait"
        no-data-text="Please select the criteria to view records."
        item-key="id"
        dense
        class="mt-8"
      >
        <template v-slot:item.status="{ item }">
          {{ item.status }}
        </template>

        <template v-slot:item.is_suspected="{ item }">
          <v-switch
            v-model="item.is_suspected"
            height="0px"
            dense
            color="green"
            @change="
              item.is_suspected ? dialog(item) : PostRemarks(item, false)
            "
          >
          </v-switch>
        </template>
        <template v-slot:item.risk_status="{ item }">
          <v-chip
            v-if="item.risk_status"
            label
            small
            outlined
            :color="returnColor(item.risk_status)"
          >
            {{ item.risk_status }}
          </v-chip>
          <span v-else>{{ item.risk_status }}</span>
        </template>
        <template v-slot:item.country="{ item }">
          <div class="d-flex justify-content-start mb-2">
            <span>
              <country-flag
                :country="item.country_code"
                :shadow="true"
                :rounded="true"
                style="margin-top: 1px"
              />
            </span>
            <span class="ml-3 mt-2">
              {{ item.country }}
            </span>
          </div>
        </template>
        <template v-slot:item.upload_files="{ item }">
          <img
            v-if="item.upload_files"
            class="ml-1"
            height="40"
            width="50"
            :src="item.upload_files"
            @click="handleImageViewer(item.upload_files, 'showImage')"
          />
        </template>
        <template v-slot:item.transaction_id="{ item }">
          <a
            title="View Transaction Details"
            class="border-d"
            @click="viewTxn(item)"
            >{{ item.transaction_id }}</a
          >
        </template>
      </v-data-table>
      <v-dialog v-model="openDialog" width="500" persistent>
        <v-card>
          <v-card-title class="text-h5">Request File</v-card-title>
          <v-divider class="p-0 m-0"></v-divider>
          <v-card-text>
            <v-form ref="requestFile">
              <v-checkbox
                v-model="request"
                label="Request file from user."
                disabled
                hide-details
              ></v-checkbox>
              <v-text-field
                label="Remarks"
                v-model="transData.remarks"
                :rules="[(v) => !!v || 'Remarks is required']"
                dense
                outlined
                placeholder="Enter Remarks"
                class="rounded mt-3"
              ></v-text-field>
            </v-form>
          </v-card-text>

          <v-divider class="p-0 m-0"></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="primary"
              outlined
              @click="openDialog = false"
            >
              <v-icon small class="me-2">mdi-close-circle-outline</v-icon>cancel
            </v-btn>
            <v-btn depressed color="primary" @click="PostRemarks('', true)">
              <v-icon small class="me-2">mdi-content-save-check-outline</v-icon>
              Submit
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
    <loading
      :active="isloadagents"
      :is-full-page="false"
      :opacity="0.7"
      color="#ff6b00"
    />
    <image-viewer
      :showDialog="isImageViewer"
      :picture="{
        PicHeight: '435',
        PicWidth: 600,
        Pic: imageViewerUrl,
      }"
      @closeImageViewer="handleCloseImageViewer"
    ></image-viewer>
  </section>
</template>

<script>
import alerts from "@/mixins/alerts";
import Loading from "vue-loading-overlay";
import imageViewer from "@/utils/imageViewer.vue";
import BreadCrumb from "@/components/navigations/BreadCrumb.vue";
import PaymentService from "@/services/PaymentService/paymentService.js";
import partnerService from "@/services/partnerService/partnerService.js";
import userService from "@/services/UserService/userService.js";
export default {
  mixins: [alerts],
  name: "Transaction",
  data: () => {
    return {
      headers: [
        { text: "Txn Id", value: "transaction_id" },
        { text: "Partner Txn Id", value: "partner_txn_id" },
        { text: "Txn Type", value: "txn_type" },
        { text: "Txn Behalf Type", value: "txn_behalf_type" },
        // {
        //   text: "Main Channel Partner",
        //   value: "cre_parent_agent_cd",
        //   width: "200px",
        // },
        { text: "Channel Partner", value: "parent_coll_sub_agent_cd" },
        { text: "Sender Name", value: "sender_name", align: "start" },
        { text: "Beneficiary Name", value: "beneficiary_name", align: "start" },
        { text: "Txn Date", value: "send_date" },
        { text: "Beneficiary country", value: "country" },
        { text: "Txn status", value: "status" },
        { text: "Relationship", value: "relation_with_remitter" },
        { text: "Payout Amount", value: "amount_sent" },
        { text: "Collected Amount", value: "receiving_amount" },
        { text: "Payment Mode", value: "mode_of_payment" },
        { text: "Risk Status", value: "risk_status" },
        { text: "Request File", value: "is_suspected" },
        { text: "Remarks", value: "remarks" },
        { text: "Uploaded File", value: "upload_files" },
      ],
      from_date: null,
      to_date: null,
      isActive: null,
      transactionList: [],
      openDialog: false,
      isLoading: false,
      request: true,
      search: "",
      is_suspected: null,
      isImageViewer: false,
      imageViewerUrl: "",
      expanded: [],
      singleExpand: false,
      isloadagents: false,
      searchInputs: {
        partner_id: null,
        to_date: new Date().toJSON().slice(0, 10),
        from_date: new Date().toJSON().slice(0, 10),
        txn_status: "All",
      },
      tempCountries: [],
      country: [],
      selectedcoutry: [],
      senderPartners: [],
      transData: {
        txn_id: "",
        login_id: "",
        remarks: "",
      },
    };
  },

  components: {
    BreadCrumb,
    imageViewer,

    Loading,
  },
  isActive() {
    return this.searchInputs.beneficiary_name;
  },
  mounted() {
    this.getAllSendPartners();
    if (this.$route.query.All_transcations) {
      this.totalTrans();
    }
    if (this.$route.query.Today_transcations) {
      this.searchInputs.txn_status = "Paid";
      this.getTransaction({
        partner_id: this.searchInputs.partner_id,
        txn_status: this.searchInputs.txn_status,
        from_date: this.searchInputs.from_date,
        to_date: this.searchInputs.to_date,
        skip: 0,
        limit: 1000,
      });
    }
    if (this.$route.query.Trans_hold) {
      this.Transhold();
    }
    if (this.$route.query.Trans_cancel) {
      this.TransCancel();
    }
  },
  watch: {
    transactionList(item) {
      console.log(item);
    },
  },
  computed: {},

  methods: {
    returnColor(val) {
      if (val.toLowerCase() == "medium") {
        return "orange";
      } else if (val.toLowerCase() == "high") {
        return "error";
      } else if (val.toLowerCase() == "low") {
        return "success";
      }
      return;
    },
    viewTxn(item) {
      this.$router.push({
        name: "Hold Details",
        query: {
          id: item.id,
          payment_id: item.transaction_id,
          from: "txn",
          risk_status: item.risk_status,
        },
      });
    },
    async downloadExcelsheet() {
      if (this.transactionList) {
        this.exportToExcel(
          this.headers,
          this.transactionList,
          "transaction_List",
        );
      }
    },
    validateFromDate(value) {
      if (value && this.searchInputs.to_date) {
        return (
          value <= this.searchInputs.to_date ||
          "From date cannot be later than To date"
        );
      }
      return true;
    },
    validateToDate(value) {
      if (value && this.searchInputs.from_date) {
        return (
          value >= this.searchInputs.from_date ||
          "To date cannot be earlier than From date"
        );
      }
      return true;
    },

    handleCloseImageViewer() {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = "";
    },
    handleImageViewer(url) {
      this.isImageViewer = !this.isImageViewer;
      this.imageViewerUrl = url;
    },
    dialog(data) {
      console.log("data", data);
      this.openDialog = true;
      this.transData.login_id = data.login_id;
      this.transData.txn_id = data.id;
      this.transData.is_suspected = data.is_suspected;
    },
    loadDetails(item) {
      console.log(item);
      console.log(item.item.id);
      this.getTransactionByID(item.item.id, item.item.transaction_id);
    },
    async getAllSendPartners() {
      try {
        const responseData = await partnerService.getAllSenderPartners();
        if (responseData.data.status_code === 200) {
          this.senderPartners = responseData.data.data.map((i) => {
            return { txt: i.partner_name, val: i.partner_id };
          });
        }
        console.log("payments", responseData);
      } catch (e) {
        console.error(e);
      }
    },
    async getFilterTransaction(params) {
      this.isloadagents = true;
      console.log(this.searchInputs);

      try {
        const responseData = await PaymentService.getTransitionDetails(params);
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data.reverse();
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        this.isActive = !this.isActive;
      } catch (e) {
        console.error(e);
        this.isloadagents = false;
      }
    },
    async getTransaction() {
      this.isloadagents = true;
      console.log(this.searchInputs);
      const params = {
        beneficiary_name: this.searchInputs.beneficiary_name,
        partner_id: this.searchInputs.partner_id,
        pin_number: this.searchInputs.pin_number,
        txn_status: this.searchInputs.txn_status,
        from_date: this.searchInputs.from_date,
        to_date: this.searchInputs.to_date,

        skip: 0,
        limit: 100000000000000,
      };
      try {
        const responseData = await PaymentService.getTransitionDetails(params);
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data.reverse();
        } else {
          this.showAlertError(`Failed: ${responseData.data.message}`);
        }
        this.isActive = !this.isActive;
      } catch (e) {
        console.error(e);
        this.isloadagents = false;
      }
    },
    async PostRemarks(data, notify) {
      this.isloadagents = true;
      let paramData = {};
      let authenticate = notify ? this.$refs.requestFile.validate() : true;
      if (notify) {
        paramData = {
          transaction_id: this.transData.txn_id,
          login_id: this.transData.login_id,
          remarks: this.transData.remarks,
          is_notified: true,
        };
      } else {
        paramData = {
          transaction_id: data.id,
          login_id: data.login_id,
          remarks: "",
          is_notified: false,
        };
      }

      if (authenticate) {
        try {
          const responseData = await PaymentService.postRemarks(paramData);
          this.isloadagents = false;
          if (responseData && responseData.data.status_code === 200) {
            this.showAlertSuccess(responseData.data.message);
            this.getTransaction();
            this.openDialog = false;
          }
        } catch (e) {
          this.isloadagents = false;
          console.error(e);
        }
      }
    },

    clear() {
      this.searchInputs.beneficiary_name = "";
      this.searchInputs.partner_id = null;
      this.searchInputs.pin_number = "";
      this.searchInputs.txn_status = "All";
      this.searchInputs.from_date = null;
      this.searchInputs.to_date = null;
      this.getTransaction();
    },

    // selectCountry() {
    //   this.country = [];
    //   this.tempCountries.forEach((data) => {
    //     this.searchInputs.forEach((country) =>{
    //       if(data.country_name == country){
    //       this.country.push(data)
    //     }
    //     })

    //   })
    //  console.log(this.searchInputs,JSON.stringify( this.country))

    // }

    async getTransactionByID(login_id, transID) {
      const params = {
        skip: 0,
        limit: 100,
      };
      try {
        const responseData = await PaymentService.getTransitionHistory(
          transID,
          login_id,
          params,
        );
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionDetails = responseData.data.data;
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.getTransactionByID(login_id, transID);
        // }
      } catch (e) {
        console.error(e);
      }
    },
    async totalTrans() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTotalTrans();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.totalTrans();
        // }
        console.log("totalTrans", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async todaysTrans() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTodayTrans();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data;
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.todaysTrans();
        // }
        console.log("todaysTrans", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async Transhold() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTransHold();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data[0];
        }
        //  else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.Transhold();
        // }
        console.log("Transhold", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
    async TransCancel() {
      this.isloadagents = true;
      try {
        const responseData = await userService.getTransCancel();
        this.isloadagents = false;
        if (responseData && responseData.data.status_code === 200) {
          this.transactionList = responseData.data.data[0];
        }
        // else if (responseData.data.status_code === 401) {
        //   this.returnNewToken();
        //   this.TransCancel();
        // }
        console.log("TransCancel", responseData);
      } catch (e) {
        this.isloadagents = false;
        console.error(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/global.scss";
/* .v-messages {
  min-height: 0px !important;
} */
.v-radio.v-label {
  margin-bottom: 0px !important;
}
.v-input--selection-controls .v-radio > .v-label {
  margin: auto !important;
}
.v-input--selection-controls__input + .v-label {
  margin: auto !important;
}
.v-sheet--offset {
  top: -20px;
  width: 100px;
  height: 30px;
  position: relative;
  border-radius: 5px;
  // border: 1px solid $secondary;
}
.v-sheet--offset1 {
  top: -20px;
  position: relative;
  border-radius: 10px;
  background-color: rgb(131, 24, 24) !important;
}
.bord-color {
  // border: 1px solid $secondary;
  border-radius: 10px;
}
table {
  font-family: "Open Sans", sans-serif;
  border: none;
  width: 100%;

  tbody {
    td {
      text-align: left;
      padding: 5px;
      vertical-align: middle;
      font-size: 14px;
      font-weight: normal;
      border: none;
      margin: 5px;
    }
  }
}
</style>
